// removed by extract-text-webpack-plugin
module.exports = {"fieldset":"c-ContactDetailsForm__fieldset","addressReadOnly":"c-ContactDetailsForm__addressReadOnly"};